<template>
    <div>
      <p class="ArticleNormal">
        在你印象中，哪个城市最火？
      </p>
      <p class="ArticleNormal">
        聊起这个话题，成都、重庆、上海、西安、杭州等城市成为很多人脑海里闪现的第一选项。而这些大火的城市能够在人们心中留下深刻印象，与短视频的营销助推密不可分，有人曾总结抖音不但红透了一个个戏精，笑“死”了一个个路人，还“抖”出了一个个网红城市。
      </p>
      <p class="ArticleNormal">
        一个个在抖音上走红的城市，宣告着发挥短视频内容优势及传播优势，放大各地城市特色属性，成为城市营销的潮流趋势。城市应如何顺势而为，借助短视频实现自身形象的塑造与传播？
      </p>
      <p class="ArticleNormal">
        巨量引擎通过SIRFA模型输出一座城市的五边雷达图，分析城市中景区、商业综合体、民宿酒店、特色美食、文化场馆五大模块的繁荣度数据，即可直观呈现该城市线上各方面的表现，据此能够有针对性地为一座城市传播提供诊断与线上营销策略。
      </p>
      <img src="../../../assets/1st/Articles/Article_5/contant_1.jpg"/>
      <p class="ArticleNormal">
        依据城市线上繁荣度指数SIRFA模型中传播度、影响度、推荐度、好感度、吸引度五个维度，可以提炼每个维度需把握的核心点，即线上构建美好城市五大关键词：流量、互动、达人、内容、沉淀。
      </p>
      <p class="ArticleNormal">
        然而，正如SIRFA的五个评估维度并非相互割裂的指标，维度所对应的五大关键词同样是相互链接的关系，相互配合共同成就一座城市的品牌力。
      </p>
      <p class="ArticleHead">
        量身定制“城设”  提升城市好感度
      </p>
      <p class="ArticleNormal">
        打造美好城市，从塑造美好“城设”开始。
      </p>
      <p class="ArticleNormal">
        无论是在夜晚的成都街头来一场“室外演唱会”，还是在新晋“网红地”成都五岔子大桥上录一段“打卡短视频”，亦或是商业街上溜达时累了饿了来一个“冒菜冰粉杯”……这些短视频内容的分享扩散，在成都名片上打出“安逸”“巴适”的城市特色。
      </p>
      <p class="ArticleNormal">
        成都也一向是玩转“城设”的标杆城市。在巨量引擎联合中规院发布《美好城市指数：短视频与城市繁荣关系白皮书》中，2020上半年十大美好城市榜的TOP1城市，成都联合抖音进行城市宣传时，就在不断明确和放大城市本身的特质——“人人都可以从中找到自己想要的生活”，并围绕这一特色品牌定位，推出城市代表性文化符号、丰富游玩体验、提升服务能力。
      </p>
      <p class="ArticleNormal">
        “城设”作为大众感知城市气质的来源，成为撬动城市形象传播的重要支点，如何让成都式的“城设”打造逻辑变得可复制、可借鉴？如何让下一批“美好之城”在线上崛起？
      </p>
      <p class="ArticleNormal">
        首先，城市需挖掘城市定位，进行面向大众的“心智占领”。这种定位可以是具体的物象，比如一说火锅就想到了重庆，一说椰子就想到了海南；也可以是一种感觉、一种情绪——比如成都的慢生活、上海的国际化。在所有城市形象传播行动开始之前，设定定位，将城市特色凝结在明确的“城设”标签上，有助于城市名片的打造。
      </p>
      <p class="ArticleNormal">
        在精准定位之上，城市需寻找到合适的传播载体，在用户心智中置入“美好城市”的具象化认知。当前，短视频凭借庞大的用户群、沉浸式的体验、立体的呈现方式，成为城市内容的天然种草机。
      </p>
      <p class="ArticleNormal">
        许多城市也探索出了独具竞争力的“城设”打造思路。例如，今年浙江省湖州市南浔古镇的“虾客大会”，围绕鲜香热辣的龙虾、源于古诗的侠气两大关键词，从实物与精神层面体现城市特色。无论是融入龙虾元素打造出的“虾客届”武侠人物形象，还是线上#有钳任性#的短视频挑战赛与抖音达人的“龙虾舞”，都以武侠感十足的龙虾品牌基调为轴心，塑造出南浔兼有历史韵味与年轻范儿的优质“城设”。
      </p>
      <img src="../../../assets/1st/Articles/Article_5/contant_2.png"/>
      <p class="ArticleNormal">
        “城设”之下，当充满地域特色的美食、美景、文化等美好城市形象，被短视频生动立体地展示在面前时，用户就很难不产生兴趣了，它已经在他们心里种下了草。
      </p>
      <p class="ArticleHead">
        激发用户创作  全民为城市“代言”
      </p>
      <p class="ArticleNormal">
        通过城市特色品牌定位吸引到用户的目光（流量）后，如何提升城市影响力成为城市营销又一难题。
      </p>
      <p class="ArticleNormal">
        城市是属于人的城市，不管是历史文化还是风景建筑，人始终都是城市变迁的见证着，也是城市性格养成的参与者。在过去的城市形象传播过程中，许多城市过多地以官方话语体系展现城市的“硬实力”，反而忽略了人的要素。
      </p>
      <p class="ArticleNormal">
        如何提高人的参与感？对于文旅这种重参与体验的行业，当用户无法即时拥有线下体验时，线上的体验分享及互动就显得尤为重要。在诸多短视频案例的实践中不难发现，通过互动环节的设计，能够有效激发抖音用户参与内容共创，打造城市内容裂变传播。
      </p>
      <p class="ArticleNormal">
        今年上半年，浙江横店影视城在抖音上发起了一次互动性极强的“全民演技派”挑战赛，在活动中，横店充分利用了抖音的两大产品：一是设置赠送礼品、奖励现金或流量的产品“全民任务”，在与挑战赛配合使用的过程中以奖励激发用户创作行为，并最终基于任务模式产生交互。二是包含与活动主题相符的贴纸、音乐等素材的灵感工具，用户通过贴纸互动即可扮演庆余年、延禧攻略等影视剧中的角色，在创作过程中大大增强了趣味性。
      </p>
      <p class="ArticleNormal">
        一旦全民热情被激发起来，活动的内容丰富度和创意趣味性就有了“保障”。通过互动，用户成为传播节点，则能进一步加速内容的裂变，为引爆创造可能。
      </p>
      <img src="../../../assets/1st/Articles/Article_5/contant_3.png"/>
      <p class="ArticleHead">
        构筑达人“金字塔”  为城市推荐值加分
      </p>
      <p class="ArticleNormal">
        短视频的互动玩法带动了广大用户共创内容的积极性，除此之外，不同分级与定位的抖音达人参与，可以进一步扩充城市营销的多元价值。
      </p>
      <p class="ArticleNormal">
        毋庸置疑，拥有庞大数量粉丝的头部达人在短视频平台上是可以“一呼百应”的。在其自带的粉丝流量带动下，头部达人所创作的内容势必会成为普通用户的创作范本，带动更多UGC产出。在这一过程中，平台还会以公域流量投放作为辅助，在这样的高曝光环境下，高效裂变传播便可实现。
      </p>
      <p class="ArticleNormal">
        除头部达人外，腰部、尾部达人的参与则为城市传播构建完整链条，不仅能有效提升创作丰富度、放大城市声量，还能通过本地达人的聚集，直接带动城市的本土影响力和线下转化。
      </p>
      <img src="../../../assets/1st/Articles/Article_5/contant_4.jpg"/>
      <p class="ArticleNormal">
        在今年6月份开展的第二届全球文旅创作者大会上，河南省就充分利用了这一方法，让来自于河南十个城市的千名抖音及今日头条达人参与活动为家乡创作。在头部、多领域垂类达人与本地达人的组合策略下，活动期间河南文旅相关短视频作品数同比大增241%。
      </p>
      <p class="ArticleNormal">
        而除了像河南省这样在大型活动中聚集多元化达人，在营销过程中，城市还可以邀请明星为代表的头部达人“为家乡代言”，实现城市品牌最大曝光；邀请腰部达人、本地达人从多角度解读和创作，帮助城市品牌快速打造本地影响力并有效引流。这样策略化的组团方式既满足了泛、垂两类需求，也实现了线上和线下的深度联动。
      </p>
      <p class="ArticleHead">
        携手品牌线上线下联动  实现1+1>2
      </p>
      <p class="ArticleNormal">
        作为城市经济发展的带动者和参与城市建设的相关主体，企业与城市共生共荣。优秀的企业品牌能够联合城市实现经济共创与文化共创，甚至成为一座城市的名片。
      </p>
      <p class="ArticleNormal">
        同时，企业影响力的提升，也会加深用户对其所在城市、区域的正向感知，尤其对地域聚集型企业而言，品牌营销即是面向用户传递特色地域属性的过程。最典型的案例就是推广乡村好货、产业生态的扶贫类短视频，这一类内容不仅推动了企业发展，也为城市赢得了更高美誉度。
      </p>
      <p class="ArticleNormal">
        因此，在城市宣推的过程中，城市如果能与众多知名企业或品牌形成联动，其知名度和口碑便可随之提升。
      </p>
      <p class="ArticleNormal">
        例如在“抖in City城市美好生活节”中，国货美妆品牌片仔癀就同时与北京、成都、广州等五个城市的嘉年华进行了深度合作，在线下结合每个城市特色定制打造“白润美女神轰趴馆”，充分展现出了全国多个城市的不同特色。
      </p>
      <img src="../../../assets/1st/Articles/Article_5/contant_5.png"/>
      <p class="ArticleNormal">
        这种操作方式可以从内容与转化两个维度进行归纳：
      </p>
      <p class="ArticleNormal">
        内容层面，每个抖音官方账号可视为一个私域流量池，能够沉淀内容与用户关系并实现长尾传播，最终联合成就一座美好城市的吸引力；转化层面，企业主可通过认领POI，组合多种产品如团购券、直播等打造转化链路，最终为POI所在的城市起到推广和转化的作用。
      </p>
      <p class="ArticleNormal">
        由此，城市通过与企业品牌进行线上线下联动，能够更好地实现多元效应、放大效应与协同效应，为城市画卷增添更具竞争力的注脚。
      </p>
      <p class="ArticleHead">
        汇聚资源形成“合力”  助推城市传播
      </p>
      <p class="ArticleNormal">
        城市营销需利用网络营销富媒体、多渠道、可交互等优势，来覆盖和影响更多用户。
      </p>
      <p class="ArticleNormal">
        在线上营销中，最常规、直接的方式是在站内做Topview、开屏、信息流等形式的广告投放。但值得关注的是，短视频平台在现阶段也已探索出了更多元化的方式，可以帮助城市进行多渠道推广。
      </p>
      <p class="ArticleNormal">
        例如平台可以直接提供全面的营销方案，帮助城市宣传方掌握投放节奏、流程安排，在短期活动以集中投放的方式提升曝光度，在长期品牌宣传中安排好预热、集中爆发及后期稳定投放的节奏、营销方式，由此来保证营销推广热度延续，从而形成长尾效应。
      </p>
      <p class="ArticleNormal">
        另外，城市还可以与平台相互借势进行宣传推广，具体操作方式就是参与平台打造的各类IP活动，依靠平台来快速提升自己的影响力。特别是全国性、系列化活动的举办的过程中，会在站外进行宣传放大声量，参与活动的城市便可实现在站内站外同时引流，放大品牌声量。
      </p>
      <p class="ArticleNormal">
        例如在今年上半年，抖音曾发起“云游中国”、“云端旅游局”等活动，活动通过多种渠道资源强势推广，使用户对城市的认知和好感度快速提升，提前“种草”一个新城市作为下次出游的目的地。而这一活动在巨量渠道资源的推广下，沉淀为优质IP，这让城市可借势平台IP活动放大品牌声量，提高曝光。
      </p>
      <img src="../../../assets/1st/Articles/Article_5/contant_6.png"/>
      <p class="ArticleNormal">
        随着城市化不断发展，品牌建设已成为带动城市区域发展、让居民产生自豪感的必要方式，因此研究如何更好帮助城市进行品牌营销，具有重大现实意义。
      </p>
      <p class="ArticleNormal">
        从上述诸多成功案例中，巨量引擎归纳已经总结出了五大方法论，这五种方法论并不孤立，而是彼此联系形成了一个完整的闭环。每个城市都可从方法论中探索适合自身的方案，同时在平台帮助下，城市品牌建设的速度也可以进一步加快。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article5"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article5.vue